export const formatFileSize = (bytes: number): string => {
  // Codex r1: negative, NaN or infinite input never prints "NaN undefined"
  if (!Number.isFinite(bytes) || bytes <= 0) return '0 B';
  const units = ['B', 'KB', 'MB', 'GB'];
  const index = Math.min(
    3,
    Math.max(0, Math.floor(Math.log(bytes) / Math.log(1024)))
  );
  return `${Math.round(bytes / 1024 ** index)} ${units[index]}`;
};
